// AuditLogsPage.tsx — Phase 1 : stub fonctionnel
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { PageHeader } from '@/components/layout/PageHeader'
import { PageContainer } from '@/components/layout/PageHeader'
import { Card, CardContent, Badge } from '@/components/ui'
import { DataTable } from '@/components/shared/DataTable/DataTable'
import { DataTableToolbar, DataTableServerPagination } from '@/components/shared/DataTable/DataTableToolbar'
import { usePagination } from '@/hooks'
import { adminApi } from '@/modules/admin/api/admin.api'
import { formatDateTime } from '@/lib/formatters'
import type { ColumnDef } from '@tanstack/react-table'

export default function AuditLogsPage() {
  const [search, setSearch] = useState('')
  const { page, limit, setPage, setLimit } = usePagination({ initialLimit: 50 })

  const { data, isLoading } = useQuery({
    queryKey: ['audit-logs', { page, limit, search }],
    queryFn: () => adminApi.getAuditLogs({ page, limit, search }),
  })

  const columns: ColumnDef<any>[] = [
    {
      accessorKey: 'createdAt',
      header: 'Date',
      cell: ({ row }) => <span className="text-[var(--tx3)] text-xs">{formatDateTime(row.original.createdAt)}</span>,
    },
    {
      accessorKey: 'user',
      header: 'Utilisateur',
      cell: ({ row }) => (
        <span className="text-[var(--tx2)] text-sm">
          {row.original.user?.firstName} {row.original.user?.lastName}
        </span>
      ),
    },
    {
      accessorKey: 'action',
      header: 'Action',
      cell: ({ row }) => (
        <code className="text-xs bg-white px-2 py-0.5 rounded text-[var(--blue-d)]">
          {row.original.action}
        </code>
      ),
    },
    {
      accessorKey: 'resourceType',
      header: 'Ressource',
      cell: ({ row }) => <Badge variant="default" size="sm">{row.original.resourceType}</Badge>,
    },
    {
      accessorKey: 'ipAddress',
      header: 'IP',
      cell: ({ row }) => <span className="text-[var(--tx3)] text-xs">{row.original.ipAddress}</span>,
    },
  ]

  return (
    <PageContainer>
      <PageHeader
        title="Journal d'audit"
        description="Historique de toutes les actions effectuées dans le système"
        breadcrumb={[{ label: 'Administration' }, { label: 'Journal d\'audit' }]}
      />
      <Card>
        <CardContent className="p-0">
          <div className="p-4 border-b border-[var(--bd)]">
            <DataTableToolbar onSearch={setSearch} searchPlaceholder="Filtrer par action, utilisateur..." />
          </div>
          <DataTable columns={columns} data={data?.data ?? []} isLoading={isLoading} emptyTitle="Aucun log" />
          {data?.meta && <DataTableServerPagination meta={data.meta} onPageChange={setPage} onLimitChange={setLimit} />}
        </CardContent>
      </Card>
    </PageContainer>
  )
}
